import { Component } from '@angular/core';
import { NavController, NavParams, ToastController } from 'ionic-angular';
import { GN } from '../../../gn';
import { DIC } from '../../dic';

/**
 * Generated class for the RoaddirectionseditPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-roaddirectionsedit',
  templateUrl: 'roaddirectionsedit.html',
})
export class RoaddirectionseditPage {
  obj: any;
  Title = ''
  _patenbroj = ''
  _brojackomesto = ''
  _patenpravec = ''
  _denovizabroenje: any = ''

  constructor(public navCtrl: NavController, public navParams: NavParams, public gn: GN, public dic: DIC, public toastCtrl: ToastController) {
    this.obj = navParams.get('obj')
    if (this.obj.id == -1) {
      this.Title = this.dic.l["addroaddirection"]
    }
    else {
      this.Title = this.dic.l["editroaddirection"]
      this._patenbroj = this.obj.patenbroj
      this._brojackomesto = this.obj.brojackomesto
      this._patenpravec = this.obj.patenpravec
      this._denovizabroenje = this.obj.denovizabroenje
    }
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad RoaddirectionseditPage');
  }

  isNumber(numb) {
    if (numb + '' != '' && numb % 1 === 0) {
      return true
    }
    else {
      return false
    }
  }

  adddirect() {
    if (this._patenbroj == '') {
      let toast = this.toastCtrl.create({ message: this.dic.l["roaddirectionnumchoose"], duration: 3000, position: 'top' });
      toast.present();
      return
    }

    if (this._patenpravec == '') {
      let toast = this.toastCtrl.create({ message: this.dic.l["roaddirectionchoose"], duration: 3000, position: 'top' });
      toast.present();
      return
    }

    if (this.isNumber(this._denovizabroenje) == false) {
      let toast = this.toastCtrl.create({ message: this.dic.l["countingdayspleasenumber"], duration: 3000, position: 'top' });
      toast.present();
      return
    }

    var _dat = {
      patenbroj: this.gn.crypt(this._patenbroj),
      brojackomesto: this.gn.crypt(this._brojackomesto),
      patenpravec: this.gn.crypt(this._patenpravec),
      denovizabroenje: this.gn.crypt(this._denovizabroenje),
      id: this.gn.crypt(this.obj.id),
      clientid: this.gn.crypt(this.gn.user.ClientId)

    }
    var _that = this
    this.gn._Post('/api/gn/addDirections', _dat, function (_data) {
      var _cb = _that.navParams.get('cb')
      if (_cb != null) {
        _cb()
      }
      var _msg = _that.dic.l["succaddroaddirection"]
      if (_that.obj.id + '' != '-1') {
        _msg = _that.dic.l["succadedditroaddirection"]
      }
      let toast = _that.toastCtrl.create({
        message: _msg,
        duration: 3000,
        position: 'top'
      });
      toast.present();
      _that.navCtrl.pop()
    })

  }


}



// WEBPACK FOOTER //
// ./src/pages/settings/roaddirections/roaddirectionsedit.ts